import React from 'react'
import Subject from './Subject'

import cse from '../assets/CSE406end21.pdf'
export default function Dbms() {
  return (
    <div>
       <Subject title="Database Management System Lab(CSE406)" sub="DBMS_LAB" syllabus="#"
    book1=""
    book1Link="#" int21="#" mid21="#" end21={cse}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}
